"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SymbolAssetBuilder = exports.SymbolAsset = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var SymbolAsset = /** @class */ (function () {
    function SymbolAsset() {
    }
    SymbolAsset.getSymbols = function (symbolAssets) {
        return symbolAssets.map(function (asset) { return asset.symbol; });
    };
    return SymbolAsset;
}());
exports.SymbolAsset = SymbolAsset;
var SymbolAssetBuilder = /** @class */ (function () {
    function SymbolAssetBuilder(symbolAsset) {
        this.symbolAsset = symbolAsset;
    }
    SymbolAssetBuilder.initialiseWithSymbolAsset = function (SymbolAsset) {
        return new SymbolAssetBuilder(SymbolAsset);
    };
    SymbolAssetBuilder.initialise = function (ownerPartyId, sharedWithEveryone, symbol) {
        return SymbolAssetBuilder.initialiseWithSymbolAsset({
            id: symbol.id,
            ownerPartyId: ownerPartyId,
            public: sharedWithEveryone,
            symbol: symbol,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    SymbolAssetBuilder.prototype.build = function () {
        return this.symbolAsset;
    };
    SymbolAssetBuilder.prototype.buildUpdate = function () {
        return {
            ownerPartyId: this.symbolAsset.ownerPartyId,
            public: this.symbolAsset.public,
            symbol: this.symbolAsset.symbol
        };
    };
    SymbolAssetBuilder.prototype.getId = function () {
        return this.symbolAsset.id;
    };
    SymbolAssetBuilder.prototype.withId = function (id) {
        this.symbolAsset.id = id;
        this.symbolAsset.symbol.id = id;
        return this;
    };
    SymbolAssetBuilder.prototype.withSymbolUpdate = function (symbolUpdate) {
        this.symbolAsset = {
            id: this.symbolAsset.id,
            ownerPartyId: this.symbolAsset.ownerPartyId,
            public: this.symbolAsset.public,
            symbol: __assign(__assign({}, this.symbolAsset.symbol), symbolUpdate),
            createdAt: this.symbolAsset.createdAt,
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        };
        return this;
    };
    return SymbolAssetBuilder;
}());
exports.SymbolAssetBuilder = SymbolAssetBuilder;
